/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto } from './FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto {
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto
     */
    Geo: FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto {
    if (!('Geo' in value) || value['Geo'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Geo': FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSON(json['geo']),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'geo': FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSON(value['Geo']),
    };
}

